import { render, staticRenderFns } from "./BatchSelection.vue?vue&type=template&id=659c616b&scoped=true&"
import script from "./BatchSelection.vue?vue&type=script&lang=js&"
export * from "./BatchSelection.vue?vue&type=script&lang=js&"
import style0 from "./BatchSelection.vue?vue&type=style&index=0&id=659c616b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659c616b",
  null
  
)

export default component.exports